"use strict";exports.__esModule = true;exports.default = void 0;var _default = /*#__PURE__*/function () {function _default() {}var _proto = _default.prototype;_proto.
  toggleDetails = function toggleDetails(ev) {
    this.emit('toggle', { originalEvent: ev, open: this.getEl('root').open });
  };_proto.
  clickDetails = function clickDetails(ev) {
    this.emit('click', { originalEvent: ev });
  };return _default;}();exports.default = _default;module.exports = exports.default;